import {FormatMessageFunction} from '../../types';

const advantages = (formatMessage: FormatMessageFunction): string[] => [
  formatMessage({id: 'advisor.advantage.refer'}),
  formatMessage({id: 'advisor.advantage.track'}),
  formatMessage({id: 'advisor.advantage.lenders'}),
];

export default advantages;
